
const digest = 'eb4e1b8d4bfc154e024b8509f267a3f9d6d67cb61c6b92129ff03a03eb7a51db';
const classes = {"wrapper":"_wrapper_evtot_1","select":"_select_evtot_12","date":"_date_evtot_15","content":"_content_evtot_25","controls":"_controls_evtot_33","invalid":"_invalid_evtot_44","pending":"_pending_evtot_48"};
const css = `._wrapper_evtot_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 28px;
  border-bottom: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_evtot_1:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_evtot_1 ._select_evtot_12 {
  padding-left: 24px;
}
._wrapper_evtot_1 ._select_evtot_12 + ._date_evtot_15 {
  padding-left: 0;
}
._wrapper_evtot_1 ._date_evtot_15 {
  font-size: 14px;
  color: #000000;
  max-width: 120px;
  padding: 24px 0 24px 24px;
  min-width: 160px;
}
._wrapper_evtot_1 ._content_evtot_25 {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 24px 0;
  flex-wrap: wrap;
}
._wrapper_evtot_1 ._controls_evtot_33 {
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 24px;
  margin: -24px 0;
  gap: 16px;
}

._invalid_evtot_44 {
  background-color: #f8dadb;
}

._pending_evtot_48 {
  background-color: #fde7cf;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  